import { h } from 'preact';

export const CAT_VIEWBOX = '0 0 665 795';

export const CAT_TEETH = [
    // Upper incisors: Triadan numbers from the midline outward, so the central
    // incisors (nearest the midline) are 101/201 and the corner incisors
    // (nearest the canines) are 103/203.
    { id: '103', cx: 199, cy: 83, rx: 7, ry: 14, rot: -22, kind: 'incisor' },
    { id: '102', cx: 213, cy: 78, rx: 7, ry: 14, rot: -16, kind: 'incisor' },
    { id: '101', cx: 228, cy: 76, rx: 7, ry: 14, rot: -8, kind: 'incisor' },
    { id: '201', cx: 244, cy: 76, rx: 7, ry: 14, rot: 8, kind: 'incisor' },
    { id: '202', cx: 259, cy: 78, rx: 7, ry: 14, rot: 16, kind: 'incisor' },
    { id: '203', cx: 274, cy: 83, rx: 7, ry: 14, rot: 22, kind: 'incisor' },
    { id: '104', cx: 169, cy: 126, rx: 14, ry: 31, rot: 10, kind: 'canine' },
    { id: '204', cx: 313, cy: 126, rx: 14, ry: 31, rot: -10, kind: 'canine' },
    { id: '106', cx: 146, cy: 199, rx: 8, ry: 12, rot: 6, kind: 'premolar' },
    { id: '107', cx: 133, cy: 256, rx: 12, ry: 25, rot: 16, kind: 'premolar' },
    { id: '108', kind: 'premolar', path: 'M 118 294 C 136 291 152 299 157 313 C 150 323 134 332 115 328 C 106 316 109 302 118 294 Z' },
    { id: '109', cx: 105, cy: 345, rx: 15, ry: 8, rot: 8, kind: 'molar' },
    { id: '206', cx: 338, cy: 199, rx: 8, ry: 12, rot: -6, kind: 'premolar' },
    { id: '207', cx: 352, cy: 256, rx: 12, ry: 25, rot: -16, kind: 'premolar' },
    { id: '208', kind: 'premolar', path: 'M 367 294 C 349 291 333 299 328 313 C 335 323 351 332 370 328 C 379 316 376 302 367 294 Z' },
    { id: '209', cx: 381, cy: 345, rx: 15, ry: 8, rot: -8, kind: 'molar' },
    { id: '409', cx: 139, cy: 478, rx: 11, ry: 24, rot: -13, kind: 'molar' },
    { id: '408', cx: 130, cy: 522, rx: 11, ry: 24, rot: -15, kind: 'premolar' },
    { id: '407', cx: 158, cy: 575, rx: 10, ry: 22, rot: -17, kind: 'premolar' },
    { id: '309', cx: 346, cy: 478, rx: 11, ry: 24, rot: 13, kind: 'molar' },
    { id: '308', cx: 355, cy: 522, rx: 11, ry: 24, rot: 15, kind: 'premolar' },
    { id: '307', cx: 327, cy: 575, rx: 10, ry: 22, rot: 17, kind: 'premolar' },
    { id: '404', cx: 195, cy: 691, rx: 15, ry: 31, rot: 82, kind: 'canine' },
    { id: '304', cx: 290, cy: 691, rx: 15, ry: 31, rot: -82, kind: 'canine' },
    { id: '403', cx: 207, cy: 709, rx: 7, ry: 13, rot: 31, kind: 'incisor' },
    { id: '402', cx: 222, cy: 713, rx: 7, ry: 13, rot: 22, kind: 'incisor' },
    { id: '401', cx: 237, cy: 716, rx: 7, ry: 13, rot: 9, kind: 'incisor' },
    { id: '301', cx: 251, cy: 716, rx: 7, ry: 13, rot: -9, kind: 'incisor' },
    { id: '302', cx: 266, cy: 713, rx: 7, ry: 13, rot: -22, kind: 'incisor' },
    { id: '303', cx: 281, cy: 709, rx: 7, ry: 13, rot: -31, kind: 'incisor' },
];

// Deciduous (melketann) label boxes, TICKET-01850. Same layout rule as the dog
// chart (see DOG_DECIDUOUS). Cats have no deciduous lower first/second premolar
// in the Triadan sense: the lower permanent premolars are 307/308 and 407/408,
// so the lower deciduous premolars are 707/708 and 807/808 only.
export const CAT_DECIDUOUS = [
    { id: '501', x: 116, y: 16 },
    { id: '502', x: 106, y: 35 },
    { id: '503', x: 99, y: 54 },
    { id: '601', x: 326, y: 16 },
    { id: '602', x: 336, y: 35 },
    { id: '603', x: 341, y: 54 },
    { id: '504', x: 83, y: 132 },
    { id: '604', x: 374, y: 132 },
    { id: '506', x: 65, y: 206 },
    { id: '507', x: 51, y: 262 },
    { id: '508', x: 33, y: 320 },
    { id: '606', x: 386, y: 206 },
    { id: '607', x: 402, y: 262 },
    { id: '608', x: 421, y: 320 },
    { id: '808', x: 66, y: 530 },
    { id: '807', x: 66, y: 584 },
    { id: '708', x: 398, y: 530 },
    { id: '707', x: 398, y: 584 },
    { id: '804', x: 101, y: 697 },
    { id: '704', x: 360, y: 697 },
    { id: '803', x: 95, y: 718 },
    { id: '802', x: 95, y: 737 },
    { id: '801', x: 95, y: 756 },
    { id: '703', x: 334, y: 718 },
    { id: '702', x: 334, y: 737 },
    { id: '701', x: 334, y: 756 },
];

export function CatChartStatic() {
    return (
        <g>
            <path class='dc-jaw' d='M 161 91 C 135 126 128 169 128 225 C 128 281 106 332 72 369 C 97 377 117 385 130 398 C 143 394 147 374 162 382 C 176 390 177 407 183 423 C 192 401 202 393 214 401 C 223 407 226 417 234 417 C 242 417 245 405 254 399 C 268 390 279 399 287 421 C 295 402 298 388 312 383 C 327 378 334 396 347 399 C 365 387 384 378 412 371 C 377 331 356 284 356 226 C 356 168 348 126 323 91' />
            <path class='dc-jaw' d='M 187 247 C 199 243 210 248 221 248 C 233 248 239 242 250 246 C 266 252 278 279 287 308 C 301 352 306 375 334 399' />
            <path class='dc-jaw' d='M 187 247 C 168 262 155 297 145 332 C 136 361 129 384 106 398' />
            <path class='dc-jaw' d='M 103 432 C 119 484 137 535 139 604 C 141 639 137 663 147 681 C 156 696 177 697 192 683 C 194 705 212 718 229 707 C 244 722 266 716 278 697 C 296 707 320 699 330 681 C 340 664 336 639 339 604 C 345 535 364 484 382 432' />
            <path class='dc-jaw' d='M 154 432 L 237 632 C 240 642 246 645 250 633 L 331 432' />
            <path class='dc-detail' d='M 132 467 C 143 475 144 491 135 500' />
            <path class='dc-detail' d='M 127 512 C 139 522 141 538 132 549' />
            <path class='dc-detail' d='M 153 564 C 164 573 166 589 157 598' />
            <path class='dc-detail' d='M 353 467 C 342 475 341 491 350 500' />
            <path class='dc-detail' d='M 358 512 C 346 522 344 538 353 549' />
            <path class='dc-detail' d='M 332 564 C 321 573 319 589 328 598' />
            <text class='dc-jaw-label' x='209' y='219'>Upper Jaw</text>
            <text class='dc-jaw-label' x='209' y='503'>Lower Jaw</text>
        </g>
    );
}

export function CatChartLabels() {
    return (
        <g>
            <text class='dc-label' x='160' y='30'>101</text>
            <polyline class='dc-leader' points='185,26 222,26 228,64' />
            <text class='dc-label' x='150' y='49'>102</text>
            <polyline class='dc-leader' points='177,45 204,45 214,67' />
            <text class='dc-label' x='143' y='68'>103</text>
            <polyline class='dc-leader' points='171,64 194,64 203,74' />
            <text class='dc-label' x='294' y='30'>201</text>
            <polyline class='dc-leader' points='294,26 250,26 244,64' />
            <text class='dc-label' x='304' y='49'>202</text>
            <polyline class='dc-leader' points='304,45 264,45 259,66' />
            <text class='dc-label' x='309' y='68'>203</text>
            <polyline class='dc-leader' points='309,64 280,64 274,72' />
            <text class='dc-label' x='83' y='128'>104</text>
            <line class='dc-leader' x1='111' y1='124' x2='154' y2='124' />
            <text class='dc-label' x='374' y='128'>204</text>
            <line class='dc-leader' x1='353' y1='124' x2='367' y2='124' />
            <text class='dc-label' x='65' y='202'>106</text>
            <line class='dc-leader' x1='92' y1='198' x2='139' y2='198' />
            <text class='dc-label' x='386' y='202'>206</text>
            <line class='dc-leader' x1='347' y1='198' x2='384' y2='198' />
            <text class='dc-label' x='51' y='258'>107</text>
            <line class='dc-leader' x1='79' y1='255' x2='122' y2='255' />
            <text class='dc-label' x='402' y='258'>207</text>
            <line class='dc-leader' x1='363' y1='255' x2='400' y2='255' />
            <text class='dc-label' x='33' y='316'>108</text>
            <line class='dc-leader' x1='60' y1='313' x2='124' y2='313' />
            <text class='dc-label' x='421' y='316'>208</text>
            <line class='dc-leader' x1='358' y1='313' x2='420' y2='313' />
            <text class='dc-label' x='20' y='374'>109</text>
            <line class='dc-leader' x1='50' y1='369' x2='104' y2='369' />
            <text class='dc-label' x='430' y='374'>209</text>
            <line class='dc-leader' x1='380' y1='369' x2='424' y2='369' />
            <text class='dc-label' x='52' y='477'>409</text>
            <line class='dc-leader' x1='82' y1='473' x2='130' y2='473' />
            <text class='dc-label' x='66' y='526'>408</text>
            <line class='dc-leader' x1='95' y1='522' x2='121' y2='522' />
            <text class='dc-label' x='66' y='580'>407</text>
            <line class='dc-leader' x1='95' y1='576' x2='150' y2='576' />
            <text class='dc-label' x='402' y='477'>309</text>
            <line class='dc-leader' x1='357' y1='473' x2='396' y2='473' />
            <text class='dc-label' x='398' y='526'>308</text>
            <line class='dc-leader' x1='365' y1='522' x2='397' y2='522' />
            <text class='dc-label' x='398' y='580'>307</text>
            <line class='dc-leader' x1='337' y1='576' x2='397' y2='576' />
            <text class='dc-label' x='101' y='693'>404</text>
            <line class='dc-leader' x1='133' y1='689' x2='181' y2='689' />
            <text class='dc-label' x='360' y='693'>304</text>
            <line class='dc-leader' x1='304' y1='689' x2='352' y2='689' />
            <text class='dc-label' x='139' y='732'>403</text>
            <polyline class='dc-leader' points='169,728 198,728 208,714' />
            <text class='dc-label' x='139' y='751'>402</text>
            <polyline class='dc-leader' points='169,747 204,747 223,719' />
            <text class='dc-label' x='139' y='770'>401</text>
            <polyline class='dc-leader' points='169,766 211,766 236,723' />
            <text class='dc-label' x='302' y='732'>303</text>
            <polyline class='dc-leader' points='302,728 282,728 276,714' />
            <text class='dc-label' x='302' y='751'>302</text>
            <polyline class='dc-leader' points='302,747 271,747 262,719' />
            <text class='dc-label' x='302' y='770'>301</text>
            <polyline class='dc-leader' points='302,766 261,766 249,723' />
        </g>
    );
}
